<template>
  <Popup
    v-if="isVisible"
    :name="popupName"
  >
    <template v-slot:content>
      <p class="page-home__message" v-if="accountStore.properties.isCommunityless">
        {{ t('global.communitylessCubeHint') }}
      </p>
      <p class="page-home__message" v-else>
        {{ t('global.cubeNotReachableMessage') }}
      </p>
    </template>
  </Popup>
</template>
<script setup lang="ts">
  import Popup from '@/components/popups/Popup.vue'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
  import { useStrings } from '@/composables/useStrings.ts'
import { useAccountStore } from '@/stores/useAccountStore'

  const accountStore = useAccountStore();
  const popupName = 'cubeNotReachable'
  const { t } = useStrings()
  const { isVisible } = useSpecificPopup(popupName)
</script>
